import { IsOptional, IsString, MaxLength } from 'class-validator'

export class DocumentUploadDto {
  @IsString()
  @MaxLength(255)
  @IsOptional()
  description?: string
}
